import React, { useEffect, useState } from 'react';
import { IonApp } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { initializeAuthStore } from './store/authStore';

// ── All routes + tab bar live in MainTabs ─────────────────────────────────────
import MainTabs from './navigation/MainTabs';

// ── App-level loader: shown only during initial auth hydration ─────────────────
const AppLoader: React.FC = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    background: '#FAF8F0',
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '3px solid #E5E7EB',
      borderTopColor: '#1B5A40',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const App: React.FC = () => {
  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const initApp = async () => {
      try {
        await initializeAuthStore();
      } catch (error) {
        console.error('[App] Initialization failed:', error);
      } finally {
        if (!cancelled) setAppReady(true);
      }
    };
    initApp();
    return () => { cancelled = true; };
  }, []);

  if (!appReady) return <AppLoader />;

  return (
    <IonApp>
      {/* IonTabs must be a direct child of IonReactRouter — no outer IonRouterOutlet */}
      <IonReactRouter>
        <MainTabs />
      </IonReactRouter>
    </IonApp>
  );
};

export default App;